import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IDonorContact } from 'src/app/interface/IDonorContact';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';
import { IDocument } from 'src/app/interface/IDocument';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  regExpEmailID = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  isValidEmail(emailIdValue: string): boolean {
    if (this.regExpEmailID.test(emailIdValue)) {
      return (true);
    } else {
      return (false);
    }
  }

  getAgreements() {
    return this.http.get<any[]>(environment.serviceURL + environment.getAgreements);
  }

  getCountry() {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getCountry);
  }

  getDonorAgency() {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getDonorAgency);
  }

  getAgreementStatus() {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getAgreementStatus);
  }

  getActivity() {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getActivity);
  }

  getTechnicalArea() {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getTechnicalArea);
  }

  getContact() {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getContact);
  }

  getDonorContacts(donorId: any) {
    return this.http.get<IDonorContact[]>(environment.serviceURL + environment.getDonorContacts + donorId);
  }

  getRegion(countryIds: any) {
    return this.http.post(environment.serviceURL + environment.getRegion, countryIds, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  getDonors() {
    return this.http.get<any[]>(environment.serviceURL + environment.getDonorsList);
  }

  getDeliverablesType() {
    return this.http.get<any[]>(environment.serviceURL + environment.getDeliverablesType);
  }

  getNotificationFrequency() {
    return this.http.get<any[]>(environment.serviceURL + environment.getNotificationFrequency);
  }

  getDocumentType() {
    return this.http.get<any>(environment.serviceURL + environment.getDocumentType);
  }

  getAllUsers() {
    return this.http.get<any>(environment.serviceURL + environment.getAllUsers);
  }

  getAdminCheck() {
    return this.http.get<any>(environment.serviceURL + environment.getAdminCheck);
  }

  uploadAttachment(attachmentmodel: any, fileObject: any) {
    const input = new FormData();
    input.append('attachmentJson', JSON.stringify(attachmentmodel));
    input.append('file', fileObject);
    return this.http.post(environment.serviceURL + environment.uploadDocument, input, { responseType: 'text'} );
  }

  saveDocument(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.saveDocument, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  downloadDocument(documentUri: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'undefined',
        'Accept': '*/*'
      })
    };
    const input = new FormData();
    input.append('documentUri', documentUri);
    return this.http.post<any>(environment.serviceURL + environment.downloadDocument, input, httpOptions);
  }

  deleteDocumnetFile(documentURI: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: documentURI
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteDocumentFile, httpOptions);
  }

  deleteDocument(delDocument: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDocument
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteDocument, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete document')));
  }

  getDocument(saveRequestBody: any) {
    return this.http.post<IDocument>(environment.serviceURL + environment.getDocumentDetails, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  getAuditDocuments(agreementId: string) {
    return this.http.get<any>(environment.serviceURL + environment.getAuditDocuments + agreementId);
  }

  getAwardAudit(agreementId: string) {
    return this.http.get<any>(environment.serviceURL + environment.getAwardAudit + agreementId);
  }

}
